import { render, staticRenderFns } from "./segmentSelect.vue?vue&type=template&id=2c30a5a5"
import script from "./segmentSelect.vue?vue&type=script&lang=js"
export * from "./segmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports